import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { GiGreenhouse, GiHamburgerMenu } from "react-icons/gi";
import { FaPhoneAlt, FaEnvelope, FaChevronDown, FaSearch, FaTimes, FaLongArrowAltRight, FaWhatsappSquare, } from "react-icons/fa";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaLinkedinIn } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { MdHomeWork } from 'react-icons/md';
import { IoIosConstruct, IoLogoWhatsapp } from 'react-icons/io';
import { GrProjects, GrResources } from 'react-icons/gr';
import { BsSignpostFill } from 'react-icons/bs';
import { AiOutlineGlobal } from 'react-icons/ai';
import { SiConsul } from 'react-icons/si';
import LanguageSwitcher from '../components/LanguageSwitcher';

const Header = () => {
    const { t } = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const toggleSearch = () => setIsSearchOpen(!isSearchOpen);
    const toggleMobileServices = () => setMobileServicesOpen(!mobileServicesOpen);

    return (
        <header className="bg-white w-full shadow-sm sticky top-0 z-50">
            {/* Top Header Section */}
            <div className="bg-[#00A3A1] py-2 px-4 hidden md:block">
                <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
                    {/* Contact Info */}
                    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 justify-center md:justify-start">
                        <div className="flex items-center">
                            <IoLogoWhatsapp className="text-[#fff] mr-2 text-lg" />
                            <a
                                href="https://wa.me/971503118846"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#fff] hover:text-green-400 text-sm"
                            >
                                +971 50 311 8846
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <FaEnvelope
                                className="text-white text-sm transition-transform duration-300 hover:scale-110 hover:text-blue-400"
                                aria-hidden="true"
                            />

                            <a
                                href="mailto:gbd@omanyefz.com"
                                className="text-white text-sm break-all transition-colors duration-300 hover:text-blue-400 hover:underline"
                                aria-label="Email to gbd@omanyefz.com"
                            >
                                gbd@omanyefz.com
                            </a>

                            <a
                                href="mailto:gbd.omanyefz@gmail.com"
                                className="text-white text-sm break-all transition-colors duration-300 hover:text-blue-400 hover:underline"
                                aria-label="Email to gbd.omanyefz@gmail.com"
                            >
                                gbd.omanyefz@gmail.com
                            </a>
                        </div>



                    </div>

                    {/* Social Links */}
                    <div className="flex text-[#fff] items-center mt-2 md:mt-0">
                        <span className="mr-3 text-sm">{t('header.followUs')}</span>
                        <div className="flex space-x-3">
                            <a href="https://www.facebook.com/share/1F55BuaQHJ/"
                                target="_blank"

                                className=" hover:text-[#4a6d6d] transition-colors"><FaFacebookF className="text-sm" /></a>
                            <a
                                href="https://www.instagram.com/omanye.fz?igsh=MTIzcGMxa3pmeG52OA=="
                                target="_blank"
                                className="hover:text-pink-600 transition-colors"
                            >
                                <FaInstagram className="text-sm" />
                            </a>
                            <a
                                href="https://wa.me/971503118846"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#fff] hover:text-green-400 text-sm"
                            >
                                <FaWhatsapp className="text-sm" />
                            </a>
                        </div>
                        <LanguageSwitcher />
                    </div>
                </div>
            </div>

            {/* Main Header Section */}
            <div className="container mx-auto  py-1">


                <div className="flex items-center justify-between">
                    {/* Logo */}
                    <div className="flex items-center space-x-3">
                        <a href="/" className="flex items-center group">
                            <img
                                src="../assets/images/logo/01.svg"
                                alt="OMANYE Logo"
                                className="h-12 md:h-16 w-auto transition-transform duration-300 group-hover:scale-105 group-hover:opacity-90"
                            />
                            <div className="ml-2 leading-tight">
                                <p className="text-base md:text-lg font-bold text-[#063970] tracking-wide">
                                    Omanye FZ-LLC
                                </p>
                                <p className="text-xs md:text-sm text-[#BCA033] font-semibold">
                                    Synergy in Exceptional Solutions
                                </p>
                            </div>
                        </a>
                    </div>



                    {/* Desktop Navigation */}



                    {/* Header Actions */}
                    <div className="flex items-center ml-3 space-x-6 ">
                        <nav className="hidden md:flex text-xl items-center space-x-8">

                            {/* About Us (only once, at the beginning) */}
                            <a href="/about-us" className=" text-[#00a3A1] hover:text-[#000] font-medium transition-colors">
                                {t('header.aboutUs')}
                            </a>

                            {/* Services Dropdown */}
                            <div className="relative group">
                                <button className="flex items-center text-[#00a3A1] hover:text-[#000] font-medium transition-colors">
                                    {t('header.services')}
                                    <FaChevronDown className="ml-1 text-xs transition-transform group-hover:rotate-180" />
                                </button>

                                {/* Mega Menu Dropdown */}
                                <div className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-screen max-w-4xl  bg-white shadow-xl rounded-md z-50 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 border border-gray-100">
                                    <div className="grid grid-cols-3  gap-6 p-6">

                                        {/* Services Column 1 */}
                                        <div className="space-y-4">
                                            <ServiceMenuItem
                                                icon="assets/images/service/04.svg"
                                                title={t('services.buildingMaterials')}
                                                description={t('services.buildingMaterialsDesc')}
                                                link="/bmc-services"
                                                isHighlighted={true}
                                                symbol={<MdHomeWork />}   // <-- Wrap the component in curly braces

                                            />
                                            <ServiceMenuItem
                                                icon="assets/images/service/05.svg"
                                                title={t('services.constructionServices')}
                                                description={t('services.constructionServicesDesc')}
                                                link="/construction-services"
                                                isHighlighted={true}
                                                symbol={<IoIosConstruct />}   // <-- Wrap the component in curly braces

                                            />
                                            <ServiceMenuItem
                                                icon="assets/images/service/06.svg"
                                                title={t('services.turnkeyProjects')}
                                                description={t('services.turnkeyProjectsDesc')}
                                                link="/turnkey-projects"
                                                isHighlighted={true}
                                                symbol={<GrProjects />}   // <-- Wrap the component in curly braces

                                            />
                                            <ServiceMenuItem
                                                icon="assets/images/service/06.svg"
                                                title={t('services.greenConstruction')}
                                                description={t('services.greenConstructionDesc')}
                                                link="/green-construction"
                                                isHighlighted={true}
                                                symbol={<GiGreenhouse />}   // <-- Wrap the component in curly braces

                                            />
                                        </div>

                                        {/* Services Column 2 */}
                                        <div className="space-y-4">
                                            <ServiceMenuItem
                                                icon="assets/images/service/07.svg"
                                                title={t('services.materialSourcing')}
                                                description={t('services.materialSourcingDesc')}
                                                link="/hassle-free-procurement"
                                                isHighlighted={true}
                                                symbol={<GrResources />}
                                            />
                                            <ServiceMenuItem
                                                icon="assets/images/service/09.svg"
                                                title={t('services.postConstruction')}
                                                description={t('services.postConstructionDesc')}
                                                link="/post-construction"
                                                isHighlighted={true}
                                                symbol={<BsSignpostFill />}
                                            />
                                            <ServiceMenuItem
                                                icon="assets/images/service/05.svg"
                                                title={t('services.globalExpansion')}
                                                description={t('services.globalExpansionDesc')}
                                                link="/global-expansion"
                                                isHighlighted={true}
                                                symbol={<AiOutlineGlobal />}

                                            />
                                            <ServiceMenuItem
                                                icon="assets/images/service/contact.svg"
                                                title={t('services.freeConsultation')}
                                                description={t('services.freeConsultationDesc')}
                                                link="/contact-us"
                                                isHighlighted={true}
                                                symbol={<SiConsul />}

                                            />
                                        </div>

                                        {/* Services Image Column */}
                                        <div className="flex items-center justify-center overflow-hidden rounded-md">
                                            <img
                                                src="assets/images/newimages/constructionhelmet.webp"
                                                alt="Construction Services"
                                                className="h-64 w-full object-cover transition-transform duration-500 hover:scale-105"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <a href="/our-products" className="text-[#00a3A1] hover:text-[#000] font-medium transition-colors">
                                {t('header.ourProducts')}
                            </a>
                            {/* Products Link */}
                            {/* <a href="/our-products" className="text-[#00a3A1] hover:text-[#000] font-medium transition-colors">
                            Solutions
                        </a>
                        <a href="/our-products" className="text-[#00a3A1] hover:text-[#000] font-medium transition-colors">
                            Our Products
                        </a> */}
                        </nav>

                        <button
                            onClick={() => window.location.href = "/contact-us"}
                            className="hidden md:inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#00A3A1] hover:bg-[#0a8f8d] transition-colors shadow-sm hover:shadow-md"
                        >
                            {t('header.contactUs')}
                            <FaLongArrowAltRight className="ml-1 text-xs" />
                        </button>


                        <button
                            onClick={toggleMenu}
                            className="md:hidden bg-gray-100 p-2 rounded-md hover:bg-gray-200 transition-colors"
                            aria-label="Menu"
                        >
                            <GiHamburgerMenu className="h-5 w-5 text-gray-700" />
                        </button>
                    </div>
                </div>

                {/* jdkdj */}
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="md:hidden bg-white shadow-lg fixed inset-0 w-full h-screen z-50 overflow-y-auto pt-4">
                    <div className="container mx-auto px-4">
                        <div className="flex justify-between items-center mb-6">
                            <a href="/" className="flex items-center">
                                <img
                                    src="../assets/images/logo/01.svg"
                                    alt="OMANYE Logo"
                                    className="h-10 w-auto"
                                />
                            </a>
                            <button onClick={toggleMenu} className="text-gray-500 hover:text-gray-700 p-2">
                                <FaTimes className="text-xl" />
                            </button>
                        </div>

                        <div className="space-y-3 pb-8">
                            <div className="border-b border-gray-200 pb-2">
                                <button
                                    onClick={toggleMobileServices}
                                    className="flex items-center justify-between w-full text-gray-800 font-medium py-2"
                                >
                                    <span>{t('mobile.ourServices')}</span>
                                    <FaChevronDown className={`text-xs transition-transform ${mobileServicesOpen ? 'rotate-180' : ''}`} />
                                </button>

                                {mobileServicesOpen && (
                                    <div className="pl-4 mt-2 space-y-3">
                                        <MobileServiceItem
                                            title={t('services.buildingMaterials')}
                                            link="/bmc-services"
                                            symbol={<MdHomeWork />}   // <-- Wrap the component in curly braces

                                        />
                                        <MobileServiceItem
                                            title={t('services.constructionServices')}
                                            link="/construction-services"
                                            symbol={<IoIosConstruct />}
                                        />
                                        <MobileServiceItem
                                            title={t('services.turnkeyProjects')}
                                            link="/turnkey-projects"
                                            symbol={<GrProjects />}
                                        />
                                        <MobileServiceItem
                                            title={t('mobile.materialSourcingProcurement')}
                                            link="/hassle-free-procurement"
                                            symbol={<GiGreenhouse />}
                                        />
                                        <MobileServiceItem
                                            title={t('mobile.greenBuilding')}
                                            link="/green-construction"
                                            symbol={<GiGreenhouse />}
                                        />

                                        <MobileServiceItem
                                            title={t('mobile.postConstructionServices')}
                                            link="/post-construction"
                                            symbol={<BsSignpostFill />}

                                        />
                                        <MobileServiceItem
                                            title={t('mobile.globalBusinessExpansion')}
                                            link="/global-expansion"
                                            symbol={<AiOutlineGlobal />}

                                        />
                                    </div>
                                )}
                            </div>

                            <a href="contact-us" className="block text-gray-800 hover:text-blue-600 font-medium py-3 border-b border-gray-200">{t('mobile.contact')}</a>
                            <a href="our-products" className="block text-gray-800 hover:text-blue-600 font-medium py-3 border-b border-gray-200">{t('mobile.ourProducts')}</a>

                            {/* Mobile Language Switcher */}
                            <div className="py-3 border-b border-gray-200">
                                <div className="flex items-center justify-between">
                                    <span className="text-gray-800 font-medium">Language / اللغة / Langue</span>
                                    <div className="flex space-x-2">
                                        <button
                                            onClick={() => i18n.changeLanguage('en')}
                                            className={`px-3 py-1 rounded text-sm font-medium transition-colors ${i18n.language === 'en'
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                                }`}
                                        >
                                            🇺🇸 EN
                                        </button>
                                        <button
                                            onClick={() => i18n.changeLanguage('fr')}
                                            className={`px-3 py-1 rounded text-sm font-medium transition-colors ${i18n.language === 'fr'
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                                }`}
                                        >
                                            🇫🇷 FR
                                        </button>
                                        <button
                                            onClick={() => i18n.changeLanguage('ar')}
                                            className={`px-3 py-1 rounded text-sm font-medium transition-colors ${i18n.language === 'ar'
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                                }`}
                                        >
                                            🇦🇪 AR
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <a
                                href="contact-us"
                                className="block w-full text-center px-4 py-3 border border-transparent text-sm font-medium rounded-md text-white bg-[#00A3A1] hover:bg-blue-700 mt-4 transition-colors"
                            >
                                {t('header.getQuote')}
                            </a>
                        </div>
                    </div>
                </div>
            )}

            {/* Search Overlay */}
            {isSearchOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-start justify-center pt-20 md:pt-32 px-4">
                    <div className="bg-white p-6 rounded-lg w-full max-w-2xl shadow-xl animate-fadeIn">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-medium text-gray-800">{t('header.whatLookingFor')}</h3>
                            <button
                                onClick={toggleSearch}
                                className="text-gray-500 hover:text-gray-700 p-1 transition-colors"
                                aria-label="Close search"
                            >
                                <FaTimes className="text-xl" />
                            </button>
                        </div>
                        <div className="relative">
                            <input
                                type="text"
                                placeholder={t('header.searchPlaceholder')}
                                className="w-full px-5 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700"
                                autoFocus
                            />
                            <button className="absolute right-4 top-3 text-gray-500 hover:text-blue-600 transition-colors">
                                <FaSearch className="text-lg" />
                            </button>
                        </div>
                        <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                            <p>{t('header.popularSearches')} <a href="/bmc-services" className="text-blue-600 hover:underline ml-2">{t('header.constructionMaterials')}</a>, <a href="/turnkey-projects" className="text-blue-600 hover:underline">{t('header.turnkeyProjects')}</a></p>

                            <Link to="/contact-us">
                                <button type='button' className='bg-[#00A3A1] rounded-md text-[#fff] px-2 py-1'>{t('header.dropQuery')}</button>
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
};

// Service Menu Item Component
const ServiceMenuItem = ({ icon, title, description, link, isHighlighted, symbol = false }) => {
    return (
        <a
            href={link}
            className={`group flex items-start p-3 rounded-md transition-all ${isHighlighted ? 'bg-blue-50 hover:bg-blue-100' : 'hover:bg-gray-50'} hover:shadow-sm`}
        >
            <div className={`flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center mr-3 ${isHighlighted ? 'bg-blue-200' : 'bg-blue-100'}`}>

                {symbol && <span className="text-2xl text-[#063970] h-5 w-5 ">{symbol}</span>}

            </div>
            <div>
                <h4 className={`text-sm font-medium ${isHighlighted ? 'text-[#063970]' : 'text-gray-800 group-hover:text-[#063970]'}`}>
                    {title}
                </h4>
                <p className="text-sm text-[#000] mt-1">{description}</p>
            </div>
        </a>
    );
};

// Mobile Service Item Component
const MobileServiceItem = ({ title, link, symbol }) => {
    return (
        <a
            href={link}
            className="flex items-center gap-2 py-2 px-3 -mx-3 rounded-md hover:bg-gray-100 text-[#063970] transition-colors"
        >
            <span className="text-lg">{symbol}</span>

            <span className="text-sm font-medium capitalize">{title}</span>
        </a>

    );
};

export default Header;